<template>
  <div class="suf">
    <h3 class="suf-title">{{ entityId ? 'Edit company' : 'Add a new company' }}</h3>

    <div v-if="busy" class="suf-busy">Working…</div>

    <div class="suf-grid">
      <div class="suf-field">
        <label>Company Number</label>
        <input type="text" class="suf-input" v-model="Code" placeholder="Company Number" />
      </div>
      <div class="suf-field">
        <label>Company Name</label>
        <input type="text" class="suf-input" v-model="Name" placeholder="Company Name" />
      </div>
    </div>

    <h4 class="suf-section">Plant Information</h4>
    <div class="suf-grid">
      <div class="suf-field">
        <label>Plant Name</label>
        <input type="text" class="suf-input" v-model="Plant.name" placeholder="Plant Name" />
      </div>
      <div class="suf-field">
        <label>City</label>
        <input type="text" class="suf-input" v-model="Plant.city" placeholder="City" />
      </div>
      <div class="suf-field">
        <label>Address 1</label>
        <input type="text" class="suf-input" v-model="Plant.street" placeholder="Address 1" />
      </div>
      <div class="suf-field">
        <label>State</label>
        <select class="suf-input" v-model="Plant.state">
          <option value="">Select State</option>
          <option v-for="s in statesP" :key="'ps-' + s.code" :value="s.code">{{ s.name }}</option>
        </select>
      </div>
      <div class="suf-field">
        <label>Address 2</label>
        <input type="text" class="suf-input" v-model="Plant.street2" placeholder="Address 2" />
      </div>
      <div class="suf-field">
        <label>Zip</label>
        <input type="text" class="suf-input" v-model="Plant.postalCode" placeholder="Zip" />
      </div>
      <div class="suf-field">
        <label>Address 3</label>
        <input type="text" class="suf-input" v-model="Plant.street3" placeholder="Address 3" />
      </div>
      <div class="suf-field">
        <label>Country</label>
        <select class="suf-input" v-model="Plant.country" @change="loadStates('P', Plant.country)">
          <option value="">Select Country</option>
          <option v-for="c in countries" :key="'pc-' + c.code" :value="c.code">{{ c.name }}</option>
        </select>
      </div>
    </div>

    <h4 class="suf-section">Ship To Information</h4>
    <div class="suf-grid">
      <div class="suf-field">
        <label>Ship To Name</label>
        <input type="text" class="suf-input" v-model="ShipTo.name" placeholder="Ship to Name" />
      </div>
      <div class="suf-field">
        <label>City</label>
        <input type="text" class="suf-input" v-model="ShipTo.city" placeholder="City" />
      </div>
      <div class="suf-field">
        <label>Address 1</label>
        <input type="text" class="suf-input" v-model="ShipTo.street" placeholder="Address 1" />
      </div>
      <div class="suf-field">
        <label>State</label>
        <select class="suf-input" v-model="ShipTo.state">
          <option value="">Select State</option>
          <option v-for="s in statesS" :key="'ss-' + s.code" :value="s.code">{{ s.name }}</option>
        </select>
      </div>
      <div class="suf-field">
        <label>Address 2</label>
        <input type="text" class="suf-input" v-model="ShipTo.street2" placeholder="Address 2" />
      </div>
      <div class="suf-field">
        <label>Zip</label>
        <input type="text" class="suf-input" v-model="ShipTo.postalCode" placeholder="Zip" />
      </div>
      <div class="suf-field">
        <label>Address 3</label>
        <input type="text" class="suf-input" v-model="ShipTo.street3" placeholder="Address 3" />
      </div>
      <div class="suf-field">
        <label>Country</label>
        <select class="suf-input" v-model="ShipTo.country" @change="loadStates('S', ShipTo.country)">
          <option value="">Select Country</option>
          <option v-for="c in countries" :key="'sc-' + c.code" :value="c.code">{{ c.name }}</option>
        </select>
      </div>
    </div>

    <div class="suf-grid">
      <div class="suf-field suf-col-2">
        <label>Instructions</label>
        <input type="text" class="suf-input" v-model="Instructions" placeholder="Instructions" />
      </div>
      <div class="suf-field">
        <label>Status</label>
        <label class="suf-check"><input type="checkbox" v-model="Active" /> Active <span class="suf-hint">(unchecked = inactive)</span></label>
      </div>
    </div>

    <div v-if="errorMsg" class="suf-error">{{ errorMsg }}</div>

    <div class="suf-actions">
      <button type="button" class="suf-save" :disabled="busy" @click="save">
        {{ busy ? 'Saving…' : (entityId ? 'Save Company' : 'Add Company') }}
      </button>
      <button type="button" class="suf-cancel" :disabled="busy" @click="$emit('cancel')">Cancel</button>
    </div>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

const emptyAddr = () => ({ name: "", street: "", street2: "", street3: "", city: "", postalCode: "", state: "", country: "US" });

export default {
  name: "SetupCompanyForm",
  props: {
    // null/empty => add a new company; otherwise the company id to edit.
    entityId: { type: [String, Number], default: null },
  },
  data() {
    return {
      Name: "",
      Code: "",
      Instructions: "",
      Active: true,
      Plant: emptyAddr(),
      ShipTo: emptyAddr(),
      countries: [],
      statesP: [],
      statesS: [],
      busy: false,
      errorMsg: "",
    };
  },
  mounted() {
    this.loadCountries();
    if (this.entityId) {
      this.loadCompany();
    } else {
      this.loadStates("P", "US");
      this.loadStates("S", "US");
    }
  },
  methods: {
    loadCountries() {
      apiService.getCountries().then((d) => { this.countries = d || []; }).catch(() => {});
    },
    loadStates(which, country) {
      const c = country || "US";
      apiService
        .getStatesByCountry(c)
        .then((d) => { if (which === "P") this.statesP = d || []; else this.statesS = d || []; })
        .catch(() => { if (which === "P") this.statesP = []; else this.statesS = []; });
    },
    loadCompany() {
      this.busy = true;
      apiService
        .getCompanyDetails({ id: this.entityId })
        .then((r) => {
          this.busy = false;
          this.Name = r.name || "";
          this.Code = r.code || "";
          this.Instructions = r.instructions || "";
          this.Active = !!r.active;
          this.Plant = Object.assign(emptyAddr(), r.plant || {});
          this.ShipTo = Object.assign(emptyAddr(), r.shipTo || {});
          this.loadStates("P", this.Plant.country || "US");
          this.loadStates("S", this.ShipTo.country || "US");
        })
        .catch(() => {
          this.busy = false;
          this.errorMsg = "Couldn't load this company — please try again.";
        });
    },
    save() {
      if (this.busy) return;
      if (!this.Code || !this.Name) { this.errorMsg = "Company Number and Company Name are required."; return; }
      this.busy = true;
      this.errorMsg = "";
      const payload = {
        name: this.Name,
        code: this.Code,
        instructions: this.Instructions,
        active: this.Active,
        plant: this.Plant,
        shipTo: this.ShipTo,
      };
      const req = this.entityId
        ? apiService.updateCompany(Object.assign({}, payload, { id: this.entityId }))
        : apiService.createCompany(payload);
      req
        .then(() => {
          this.busy = false;
          this.$emit("saved", { kind: "company" });
        })
        .catch((err) => {
          this.busy = false;
          this.errorMsg = this._errText(err) || "Couldn't save the company — please check the fields and try again.";
        });
    },
    _errText(err) {
      const r = err && err.response && err.response.data;
      if (!r) return "";
      if (typeof r === "string") return r;
      return r.title || r.message || "";
    },
  },
};
</script>

<style scoped>
.suf {
  padding: 4px 2px 8px 2px;
}
.suf-title {
  font-size: 16px;
  font-weight: 700;
  color: #2c3038;
  margin: 0 0 10px 0;
}
.suf-section {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #c0392b;
  margin: 14px 0 6px 0;
  border-bottom: 1px solid #f0d8d4;
  padding-bottom: 4px;
}
.suf-busy {
  font-size: 12px;
  color: #7b8794;
  margin-bottom: 8px;
}
.suf-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
}
.suf-field {
  flex: 1 1 calc(50% - 7px);
  min-width: 180px;
  display: flex;
  flex-direction: column;
}
.suf-col-2 {
  flex: 1 1 100%;
}
.suf-field > label {
  font-size: 11px;
  font-weight: 600;
  color: #5b6470;
  margin-bottom: 3px;
}
.suf-hint {
  font-weight: 400;
  color: #9aa3ad;
}
.suf-input {
  border: 1px solid #d6dade;
  border-radius: 5px;
  padding: 7px 9px;
  font-size: 13px;
  color: #2c3038;
  background: #fff;
  width: 100%;
}
.suf-input:focus {
  outline: none;
  border-color: #c0392b;
}
.suf-check {
  font-size: 13px;
  color: #2c3038;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 5px;
}
.suf-error {
  margin-top: 10px;
  color: #c0392b;
  font-size: 12.5px;
  font-weight: 600;
}
.suf-actions {
  margin-top: 14px;
  display: flex;
  gap: 10px;
}
.suf-save {
  background: #1e7e34;
  border: none;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  border-radius: 5px;
  padding: 8px 18px;
  cursor: pointer;
}
.suf-save:disabled {
  opacity: 0.6;
  cursor: default;
}
.suf-cancel {
  background: #fff;
  border: 1px solid #d6dade;
  color: #5b6470;
  font-weight: 600;
  font-size: 13px;
  border-radius: 5px;
  padding: 8px 16px;
  cursor: pointer;
}
</style>
